// extracted by mini-css-extract-plugin
export default {"title":"MenuTitle_title__EY+gh","isSectionsTitle":"MenuTitle_isSectionsTitle__pTVbJ"};